import { useState } from "react";

type DoubleChainConveyorControlsProps = {
  disabled?: boolean;
  initialCrossbarZInset: number;
  initialEndInset: number;
  initialXInset: number;
  initialYOffset: number;
  onCrossbarZInsetChange: (crossbarZInset: number) => void;
  onEndInsetChange: (sideRailEndInset: number) => void;
  onXInsetChange: (sideRailXInset: number) => void;
  onYOffsetChange: (sideRailYOffset: number) => void;
  initialWheelXOutset: number;
  onWheelXOutsetChange: (wheelXOutset: number) => void;
};

export function DoubleChainConveyorControls({
  disabled = false,
  initialCrossbarZInset,
  initialEndInset,
  initialXInset,
  initialYOffset,
  initialWheelXOutset,
  onCrossbarZInsetChange,
  onEndInsetChange,
  onXInsetChange,
  onYOffsetChange,
  onWheelXOutsetChange
}: DoubleChainConveyorControlsProps) {
  const [crossbarZInsetDraft, setCrossbarZInsetDraft] = useState(String(initialCrossbarZInset));
  const [endInsetDraft, setEndInsetDraft] = useState(String(initialEndInset));
  const [xInsetDraft, setXInsetDraft] = useState(String(initialXInset));
  const [yOffsetDraft, setYOffsetDraft] = useState(String(initialYOffset));
  const [wheelXOutsetDraft, setWheelXOutsetDraft] = useState(String(initialWheelXOutset));

  return (
    <div className="double-chain-conveyor-controls">
      <span className="double-chain-conveyor-controls-title">双链输送机</span>
      <label className="double-chain-conveyor-controls-field">
        <span>侧杆 Y 偏移</span>
        <span className="double-chain-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setYOffsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onYOffsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={yOffsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="double-chain-conveyor-controls-field">
        <span>侧杆 X 向内偏移</span>
        <span className="double-chain-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setXInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onXInsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={xInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="double-chain-conveyor-controls-field">
        <span>侧杆前后单侧削减</span>
        <span className="double-chain-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setEndInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onEndInsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={endInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="double-chain-conveyor-controls-field">
        <span>横杆 Z 向内偏移</span>
        <span className="double-chain-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setCrossbarZInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onCrossbarZInsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={crossbarZInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="double-chain-conveyor-controls-field">
        <span>滚轮机构 X 向外扩张</span>
        <span className="double-chain-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setWheelXOutsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onWheelXOutsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={wheelXOutsetDraft}
          />
          <span>m</span>
        </span>
      </label>
    </div>
  );
}
